export default "__VITE_ASSET__46e461c3__"